export const quizQuestions = [
  {
    id: "budget",
    step: "01",
    question: "What is your realistic monthly family budget abroad?",
    hint: "Be honest — include rent, food, school, and transport.",
    options: [
      { label: "Under $1,500 / month", desc: "Stretch every dollar", weights: { egypt: 3, indonesia: 2, morocco: 1, turkiye: 1, tanzania: 2 } },
      { label: "$1,500 – $2,500", desc: "Comfortable, not lavish", weights: { malaysia: 3, indonesia: 2, morocco: 2, turkiye: 2, tanzania: 1 } },
      { label: "$2,500 – $4,000", desc: "Comfort + good schools", weights: { malaysia: 2, morocco: 1, uae: 2, saudi: 1 } },
      { label: "$4,000+", desc: "Premium landing", weights: { uae: 3, malaysia: 1, qatar: 2, saudi: 1 } },
    ],
  },
  {
    id: "climate",
    step: "02",
    question: "What weather could your family actually live with?",
    hint: "You'll feel this every single day — choose honestly.",
    options: [
      { label: "Mild & Mediterranean", desc: "Real seasons, ocean air", weights: { morocco: 3, turkiye: 2 } },
      { label: "Hot & dry desert", desc: "Sunshine, low humidity", weights: { egypt: 2, uae: 2, morocco: 1, saudi: 2, qatar: 1 } },
      { label: "Tropical & humid", desc: "Green, warm, rainy afternoons", weights: { malaysia: 3, indonesia: 3, tanzania: 2 } },
      { label: "Anything — we adapt", desc: "Climate won't decide for us", weights: { egypt: 1, malaysia: 1, indonesia: 1, morocco: 1, uae: 1, saudi: 1, turkiye: 1, qatar: 1, tanzania: 1 } },
    ],
  },
  {
    id: "language",
    step: "03",
    question: "How much do you need English (or Arabic you know) to work?",
    hint: "Think schools, doctors, landlords, and bureaucracy.",
    options: [
      { label: "English must work everywhere", desc: "Kids' schooling & daily life in English", weights: { malaysia: 3, uae: 3, qatar: 2 } },
      { label: "I want to learn Arabic by immersion", desc: "Bring on the language bootcamp", weights: { egypt: 3, morocco: 1, saudi: 2 } },
      { label: "I can handle French / Darija", desc: "Or I'm willing to learn", weights: { morocco: 3 } },
      { label: "I'll learn whatever they speak", desc: "Bahasa, Turkish, Swahili — an adventure", weights: { indonesia: 3, egypt: 1, morocco: 1, turkiye: 2, tanzania: 2 } },
    ],
  },
  {
    id: "visa",
    step: "04",
    question: "Which visa pathway actually fits your situation?",
    hint: "Your visa decides how you rent, bank, and enroll the kids.",
    options: [
      { label: "Remote work / online income", desc: "US salary, foreign address", weights: { malaysia: 3, uae: 3, indonesia: 1, turkiye: 2 } },
      { label: "Study (me or the kids)", desc: "Quran, Arabic, Islamic schools", weights: { egypt: 3, indonesia: 2, morocco: 1, saudi: 2 } },
      { label: "Spouse's employment", desc: "A job offer leads the way", weights: { uae: 3, malaysia: 1, qatar: 2, saudi: 2 } },
      { label: "Savings & scouting first", desc: "Tourist visas while we figure it out", weights: { malaysia: 2, morocco: 2, egypt: 2, turkiye: 1, tanzania: 2 } },
    ],
  },
  {
    id: "family",
    step: "05",
    question: "Who is traveling with you?",
    hint: "Different destinations fit different caravans.",
    options: [
      { label: "Young children (under 10)", desc: "Schools & safety first", weights: { malaysia: 2, uae: 2, egypt: 1, qatar: 1 } },
      { label: "Teenagers", desc: "They need community & English", weights: { uae: 2, malaysia: 2, morocco: 1 } },
      { label: "Just me", desc: "Safety & sisterhood above all", weights: { malaysia: 3, uae: 2, morocco: 1, qatar: 1 } },
      { label: "Big family, tight budget", desc: "Maximum barakah per dollar", weights: { egypt: 3, indonesia: 2, turkiye: 2, tanzania: 1 } },
    ],
  },
  {
    id: "arabic",
    step: "06",
    question: "How important are Arabic immersion and Qur'an / hifz schools?",
    hint: "Be honest about what you'll actually prioritize once the boxes are unpacked.",
    options: [
      { label: "Essential", desc: "Arabic in the streets, hifz programs for the kids", weights: { saudi: 3, egypt: 3, qatar: 2, uae: 2, morocco: 2 } },
      { label: "Nice to have", desc: "Good Islamic schools matter; the local language can be anything", weights: { saudi: 1, egypt: 1, qatar: 1, uae: 1, morocco: 1, malaysia: 1, indonesia: 1, turkiye: 1, tanzania: 1 } },
      { label: "Not a deciding factor", desc: "We'll do Qur'an at home or online", weights: { malaysia: 2, indonesia: 2, turkiye: 2, tanzania: 1, uae: 1 } },
    ],
  },
  {
    id: "heart",
    step: "07",
    question: "Last one — what would make your heart settle?",
    hint: "The deen reason underneath all the logistics.",
    options: [
      { label: "Living near the Haramain", desc: "Makkah & Madinah as neighbors", weights: { saudi: 4 } },
      { label: "Deep Islamic heritage & beauty", desc: "Centuries of Islam under your feet", weights: { turkiye: 2, morocco: 2, saudi: 1, egypt: 1, tanzania: 1 } },
      { label: "Modern comfort & total safety", desc: "Soft landing, everything works", weights: { uae: 2, qatar: 2, malaysia: 1 } },
      { label: "Warm community & study circles", desc: "Sisterhood and students of knowledge", weights: { egypt: 2, malaysia: 1, indonesia: 1, tanzania: 1 } },
    ],
  },
];

export const scoreQuiz = (answers) => {
  const totals = {};
  answers.forEach((opt) => {
    Object.entries(opt.weights).forEach(([slug, w]) => {
      totals[slug] = (totals[slug] || 0) + w;
    });
  });
  const max = Math.max(...Object.values(totals), 1);
  return Object.entries(totals)
    .map(([slug, score]) => ({ slug, score, match: Math.round((score / max) * 100) }))
    .sort((a, b) => b.score - a.score);
};
